import { PlayerManagerProps as Props } from '../../../../../shared/types/props/player';
import { PlayerState } from '../../../../../shared/types/enums/player';
import { mediaSelector } from '../../../../../shared/store/slices/media.slice';
import { useAppSelector } from '../../../../../shared/store/hooks';
import { useEffect } from 'react';

const MILLISECONDS_TO_SECONDS = 1000;

function MediaManager({ hls: player, video }: Props) {
  const { live, position, state } = useAppSelector(mediaSelector);

  useEffect(() => {
    if (video) {
      switch (state) {
        case PlayerState.PAUSE:
          try {
            video.pause();
          } catch (error) {
            console.error('[Hls.js][Media manager] Pause');
          }
          break;

        case PlayerState.PLAY:
        case PlayerState.SEEKING:
          try {
            video.play();
          } catch (error) {
            console.error('[Hls.js][Media manager] Play');
          }
          break;

        case PlayerState.SEEK:
          try {
            if (live) {
              const range = video?.seekable;
              const livePosition = range?.end(0)
                ? range.end(0) -
                  Math.abs((position - Date.now()) / MILLISECONDS_TO_SECONDS)
                : position;
              video.currentTime = livePosition;
            } else {
              video.currentTime = position;
            }
          } catch (error) {
            console.error('[Hls.js][Media manager] Seek');
          }
          break;

        default:
          break;
      }
    }
  }, [player, position, state, video]);

  return null;
}

export default MediaManager;
